// extracted by mini-css-extract-plugin
export default {"root":"WelcomeForm_root__JLa2A","divider":"WelcomeForm_divider__s1Le1","dividerText":"WelcomeForm_dividerText__3nMTT textBodyXs","submit":"WelcomeForm_submit__Hd52J"};